import {
    getObsColors,
    levels,
    obsColWrapperData,
    observationKeys,
    operators,
} from './Constants'

export function getOffset(el) {
    if (!el) {
        return {
            x: null,
            y: null,
        }
    }
    const rect = el.getBoundingClientRect()
    return {
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY,
    }
}

export function getIncrement() {
    return localStorage.getItem('increment')
        ? JSON.parse(localStorage.getItem('increment'))
        : localStorage.getItem('increment')
}

export function setIncrement() {
    localStorage.setItem(
        'increment',
        localStorage.getItem('increment')
            ? JSON.parse(localStorage.getItem('increment')) + 1
            : JSON.stringify(0),
    )
}

export function deleteIncrement() {
    localStorage.removeItem('increment')
}

export function getLevelLabelByValue(data) {
    if (!data) {
        return ' '
    }

    let returnedLabel = ''
    for (let i = 0; i < levels.length; i++) {
        if (levels[i].value === data) {
            returnedLabel = levels[i].label
            break
        }
    }

    return returnedLabel
}

export function getValueByKeyForChart(dataList, key) {
    if (!dataList || !Array.isArray(dataList)) {
        return []
    }

    let returnedList = []
    for (let i = 0; i < dataList.length; i++) {
        if (key === observationKeys.bloodPressure) {
            let item = {}
            if (dataList[i]) {
                if (dataList[i][observationKeys.systolic]) {
                    item.systolicIndex = i
                    item.systolic = dataList[i][observationKeys.systolic]
                }

                if (dataList[i][observationKeys.diastolic]) {
                    item.diastolicIndex = i
                    item.diastolic = dataList[i][observationKeys.diastolic]
                }

                if (dataList[i][observationKeys.bloodPressureLimb]) {
                    item.bloodPressureLimb =
                        dataList[i].bloodPressureLimbShortenedValue
                }

                if (dataList[i][observationKeys.bloodPressurePosition]) {
                    item.bloodPressurePosition =
                        dataList[i].bloodPressurePositionShortenedValue
                }
            }

            if (
                dataList[i][observationKeys.systolic] &&
                dataList[i][observationKeys.diastolic]
            ) {
                returnedList.push({
                    ...item,
                    device: dataList[i].device,
                })
            }
        } else {
            if (dataList[i] && dataList[i][key]) {
                let item = {
                    index: i,
                    value: dataList[i][key],
                    device: dataList[i].device,
                }

                returnedList.push(item)
            }
        }
    }

    return returnedList
}

export function getIndexOfValueInMultiCol(dataList, value) {
    if (!dataList || !Array.isArray(dataList) || !value) {
        return null
    }

    let returnedIndex = null
    for (let i = 0; i < dataList.length; i++) {
        if (dataList[i].operator === operators.between) {
            if (
                dataList[i].start &&
                dataList[i].end &&
                dataList[i].start <= value &&
                value <= dataList[i].end
            ) {
                returnedIndex = i
                break
            }
        } else if (dataList[i].value) {
            if (dataList[i].operator === operators.greaterOrEqualTo) {
                if (value >= dataList[i].value) {
                    returnedIndex = i
                    break
                }
            } else if (dataList[i].operator === operators.lessOrEqualTo) {
                if (value <= dataList[i].value) {
                    returnedIndex = i
                    break
                }
            } else if (dataList[i].operator === operators.greaterThan) {
                if (value > dataList[i].value) {
                    returnedIndex = i
                    break
                }
            } else if (dataList[i].operator === operators.lessThan) {
                if (value < dataList[i].value) {
                    returnedIndex = i
                    break
                }
            }
        }
    }

    return returnedIndex
}

export const convertSkinTempToMBT = skinTemp => {
    if (!skinTemp) {
        return '-'
    }

    return (0.64 * 37.5 + 0.36 * skinTemp).toFixed(1)
}

export function getValueByKeyAtPosition(dataList, key, data, index) {
    if (
        !data ||
        !data[key] ||
        !dataList ||
        !Array.isArray(dataList) ||
        dataList.length < 1
    ) {
        return ''
    }

    let returnedValue = ''
    let dataValue = null
    if (
        !!data[key] &&
        data[key] > 0 &&
        key === observationKeys.temperature &&
        data['device'] === 'W'
    ) {
        dataValue = convertSkinTempToMBT(data[key])
    } else {
        dataValue = data[key]
    }

    for (let i = 0; i < dataList.length; i++) {
        if (dataList[i].operator === operators.between) {
            if (
                dataList[i].start &&
                dataList[i].end &&
                dataList[i].start <= dataValue &&
                dataValue <= dataList[i].end &&
                dataList.indexOf(dataList[i]) === index
            ) {
                returnedValue = dataValue
                break
            }
        } else if (dataList[i].value) {
            if (dataList[i].operator === operators.greaterOrEqualTo) {
                if (
                    dataValue >= dataList[i].value &&
                    dataList.indexOf(dataList[i]) === index
                ) {
                    returnedValue = dataValue
                    break
                }
            } else if (dataList[i].operator === operators.lessOrEqualTo) {
                if (
                    dataValue <= dataList[i].value &&
                    dataList.indexOf(dataList[i]) === index
                ) {
                    returnedValue = dataValue
                    break
                }
            } else if (dataList[i].operator === operators.greaterThan) {
                if (
                    dataValue > dataList[i].value &&
                    dataList.indexOf(dataList[i]) === index
                ) {
                    returnedValue = dataValue
                    break
                }
            } else if (dataList[i].operator === operators.lessThan) {
                if (
                    dataValue < dataList[i].value &&
                    dataList.indexOf(dataList[i]) === index
                ) {
                    returnedValue = dataValue
                    break
                }
            }
        }
    }

    return returnedValue
}

export function getShortenFromValue(value, dataRange) {
    if (!value) {
        return
    }

    if (!dataRange || !Array.isArray) {
        return value
    }

    let returnedShorten = ''
    for (let i = 0; i < dataRange.length; i++) {
        if (
            dataRange[i] &&
            dataRange[i].value &&
            dataRange[i].value === value
        ) {
            if (dataRange[i].shorten) {
                returnedShorten = dataRange[i].shorten
                break
            }
        }
    }

    return returnedShorten
}

export function getLabelFromKey(label) {
    if (!label) {
        return ''
    }

    let returnedLabel = ''
    for (let i = 0; i < obsColWrapperData.length; i++) {
        if (obsColWrapperData[i].key === label) {
            returnedLabel = obsColWrapperData[i].label
            break
        }
    }

    return returnedLabel
}

export function getNewsColor(score) {
    if (!score || score === 0) {
        return 'lightgray'
    }

    const obsColors = getObsColors()
    if (score === 1 || score === 2) {
        return obsColors.lv2
    }

    if (score === 3 || score === 4) {
        return obsColors.lv3
    }

    if (score === 5 || score === 6) {
        return obsColors.lv4
    }

    return 'rgb(205, 92, 92)'
}

// Check data type

export const isBoolean = value => typeof value === 'boolean'

export const isArrayAndNotEmpty = data =>
    data && Array.isArray(data) && data.length > 0

export const isObjectAndNotEmpty = value =>
    typeof value === 'object' && value !== null && Object.keys(value).length > 0
